<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <WoocommerceApiForm
            :default-data="thirdPartyService"
            :action="updateWoocommerceApiService"
            @cancel="$refs.modal.close()"
          />
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import { woocommerceApiServicesClient } from '@/api/clients';
import WoocommerceApiForm from './WoocommerceApiForm.vue';

export default {
  components: {
    WoocommerceApiForm,
    BaseCard,
  },
  props: {
    thirdPartyServiceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    thirdPartyService() {
      return this.$store.state.entities.thirdPartyServices.byId[this.thirdPartyServiceId];
    },
  },
  methods: {
    async updateWoocommerceApiService(formData) {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.thirdPartyServiceId,
          formData: { config: formData },
          service: woocommerceApiServicesClient.update,
        });

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
